import * as React from "react";
import "../styles/Modal.css";
import ReactModal from "react-modal";
import { DropdownList, orgInfo, orgTypes, GetOrgTypeDropdownList } from "../api/dataTypes";
import { hasDistributorRole } from "../api/api-account";

interface State {
    org: orgInfo;
    blockUpdates: boolean;
    distIndex: number;
    typeOptions: DropdownList[];
}

export interface Props {
    isModalOpen: boolean;
    closeModal: () => void;
    editOrg: (addUser: orgInfo, orgIndex: number) => void;
    distributorOptions: DropdownList[],
    distIndex: number,
    org: orgInfo,
    disableDropdowns?:boolean,
}

export class EditOrgModal extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            org: new orgInfo(),
            blockUpdates: false,
            distIndex: -1,
            typeOptions: GetOrgTypeDropdownList(),
        };
    }

    componentWillReceiveProps(nextProps: Props) {
        if (!nextProps.isModalOpen || (nextProps.org.name !== "")) {
            this.setState({
                org: JSON.parse(JSON.stringify(nextProps.org)),
                distIndex: nextProps.distIndex
            })
        }
    }

    render() {
        return (
            <div className="Modal">
                <ReactModal
                    ariaHideApp={false}
                    isOpen={this.props.isModalOpen}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    onRequestClose={this.props.closeModal}
                    className={{
                        base: "modal-content edit-modal",
                        afterOpen: "modal-content_after-open",
                        beforeClose: "modal-content_before-close"
                    }}
                    overlayClassName={{
                        base: "modal-overlay",
                        afterOpen: "modal-overlay_after-open",
                        beforeClose: "modal-overlay_before-close"
                    }}
                >
                    <div className="container edit-modal">
                        <label className="label-large col-form-label">
                            Edit Organization
                    </label>
                        <div className="row form-group" />
                        <div className="row form-group d-flex align-items-center">
                            <div className="col-4 modal-text">Name</div>
                            <div className="col-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={this.state.org.name}
                                    onChange={this.onInputChange}
                                    onFocus={this.onFocus}
                                    name="name"
                                    tabIndex={1}
                                />
                            </div>
                        </div>
                        <div className="row form-group d-flex align-items-center">
                            <div className="col-4 modal-text">Type</div>
                            <div className="col-8">
                                <text>
                                    {orgTypes[this.state.org.orgType]}
                                </text>
                                {/*<select
                                    className="dropdown-style"
                                    value={this.state.org.orgType}
                                    onChange={this.onTypeChange}
                                    tabIndex={2}
                                    disabled={this.props.disableDropdowns}
                                >
                                    {this.state.typeOptions.map(c =>
                                        <option key={c.value} value={c.value} >
                                            {c.name}
                                        </option>)
                                    }
                                </select>*/}
                            </div>
                        </div>
                        {this.state.org.orgType === orgTypes.Customer
                            && !hasDistributorRole() &&<div className="row form-group d-flex align-items-center">
                                <div className="col-4 modal-text">Distributor</div>
                                <div className="col-8">
                                    <select
                                        className="dropdown-style"
                                        value={this.state.distIndex}
                                        onChange={this.onDistChange}
                                        tabIndex={3}
                                        disabled={this.props.disableDropdowns}
                                    >
                                        {this.props.distributorOptions.map(c =>
                                            <option key={c.value} value={c.value} >
                                                {c.name}
                                            </option>)
                                        }
                                    </select>
                                </div>
                            </div>}
                        <div className="row form-group">
                            <div className="col">
                                <button
                                    className="btn btn-block button-standard confirm-button"
                                    disabled={this.state.org.name === '' || this.state.org.orgType === orgTypes["Not Selected"]}
                                    tabIndex={4}
                                    onClick={this.confirmButtonPressed}
                                >
                                    Confirm
                            </button>
                            </div>
                            <div className="col">
                                <button
                                    className="btn btn-block button-standard cancel-button"
                                    tabIndex={5}
                                    onClick={this.cancelButtonPressed}
                                >
                                    Close/Cancel
                            </button>
                            </div>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    }

    private onInputChange = (
        e:
            | React.SyntheticEvent<HTMLInputElement>
            | React.SyntheticEvent<HTMLSelectElement>
    ) => {
        let newOrg = this.state.org;
        newOrg[e.currentTarget.name] = e.currentTarget.value;
        this.setState({
            org: newOrg
        });
    }

    private confirmButtonPressed = () => {
        // Call change password method that was passed in
        this.props.editOrg(this.state.org, this.state.distIndex
        );
    }

    private cancelButtonPressed = () => {
        this.setState({
            org: new orgInfo(),
        });
        this.props.closeModal();
    }

    private onFocus = (e: React.SyntheticEvent<HTMLInputElement> | React.SyntheticEvent<HTMLButtonElement>) => {
        this.setState({
            blockUpdates: true
        });

    }
    // private onTypeChange = (e: React.SyntheticEvent<HTMLSelectElement>) => {
    //     // First try to parse the value that was sent - if it fails, do nothing
    //     let parsedNumber = parseInt(e.currentTarget.value, 10);
    //     let newOrg: orgInfo = this.state.org;
    //     if (!isNaN(parsedNumber)) {
    //         // Element in the dropdown has been selected
    //         newOrg.orgType = parsedNumber;
    //         this.setState({
    //             org: newOrg
    //         });
    //     }
    // }

    private onDistChange = (e: React.SyntheticEvent<HTMLSelectElement>) => {
        // First try to parse the value that was sent - if it fails, do nothing
        let parsedNumber = parseInt(e.currentTarget.value, 10);
        if (!isNaN(parsedNumber)) {
            // Element in the dropdown has been selected
            this.setState({
                distIndex: parsedNumber
            });
        }
    }
}